import { render } from "./Pano.vue?vue&type=template&id=48bf53f3"
import script from "./Pano.vue?vue&type=script&lang=js"
export * from "./Pano.vue?vue&type=script&lang=js"

import "./Pano.vue?vue&type=style&index=0&id=48bf53f3&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__